import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-complete"
export default class extends Controller {
  connect() {
    this.element.addEventListener("focus", this.onFocus)
  }
  disconnect() {
    this.element.removeEventListener("focus", this.onFocus)
  }
  onFocus() {
    this.setAttribute('autocomplete', 'new-password');
  }
}
